/**
 * Get the scrollbar width and set it as a CSS variable
 * This allows us to use the variable in CSS to offset the body
 * when the scrollbar is hidden, preventing the page from jumping
 * 
 * See html-elements.css, where there is css like
 *  body[some-attribute]{
      margin-right: var(--scrollbar-width);
      overflow: hidden;
    }

    See https://davidwalsh.name/detect-scrollbar-width
 */

const getAndSetScrollbarWidth = () => {
  // Create the measurement node
  const scrollDiv = document.createElement('div');
  scrollDiv.className = 'scrollbar-measure';
  document.body.append(scrollDiv);

  // Get the scrollbar width
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  // Set a custom property on the root element with the width
  document.documentElement.style.setProperty(
    '--scrollbar-width',
    `${scrollbarWidth}px`
  );

  // Delete the DIV
  scrollDiv.remove();
};

getAndSetScrollbarWidth();
